// extracted by mini-css-extract-plugin
export default {"formCheck":"styles_formCheck__Yrrdu"};